export default {"src":"/_next/static/media/network-security.64dcf8d3.svg","height":679,"width":715,"blurWidth":0,"blurHeight":0};